import { render } from "./index.vue?vue&type=template&id=87e6db60"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=87e6db60&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/musubisumu/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__